// extracted by mini-css-extract-plugin
module.exports = {"contentLang":"LanguageItems_contentLang__2Lp1L","active":"LanguageItems_active__sFb_m"};